/**
 * The Navigator's voices — one active per workspace (PRD-navigator-that-does-it
 * §3.1). Same job (find where to do it); a different voice around the answer.
 */

import type { AssistantMode } from '../harry/assistantMode';

export type GuideId = AssistantMode;

export const GUIDE_IDS: GuideId[] = ['concierge', 'harry', 'wes'];

export const GUIDE_JOB_TAGLINE = 'The Navigator finds where to do what a person asks';

export interface GuideAgentMeta {
  id: GuideId;
  name: string;
  /** How a sentence names it: "the plain voice", "Harry's voice". */
  voiceName: string;
  tagline: string;
  description: string;
  /** Detail page for voice/model/prompt tuning — undefined for Navigator. */
  settingsHref?: string;
  usesLlm: boolean;
}

export const GUIDE_AGENTS: Record<GuideId, GuideAgentMeta> = {
  concierge: {
    id: 'concierge',
    name: 'Plain',
    voiceName: 'the plain voice',
    tagline: 'Finds the place by the words used — no AI',
    description:
      `${GUIDE_JOB_TAGLINE}. Matches the words to the catalog of what can be done, with no AI and no persona.`,
    usesLlm: false,
  },
  harry: {
    id: 'harry',
    name: 'Harry',
    voiceName: "Harry's voice",
    tagline: "Same job, in Harry Max's voice",
    description:
      `${GUIDE_JOB_TAGLINE}. Adds an AI answer in Harry Max's voice beside what the words found.`,
    settingsHref: '/prioritization/settings/harry-agent',
    usesLlm: true,
  },
  wes: {
    id: 'wes',
    name: 'Wes',
    voiceName: "Wes's voice",
    tagline: "Same job, in Wes Bright's voice",
    description:
      `${GUIDE_JOB_TAGLINE}. Adds an AI answer in Wes Bright's voice beside what the words found.`,
    settingsHref: '/prioritization/settings/wes-agent',
    usesLlm: true,
  },
};

export function getGuideAgent(id: GuideId): GuideAgentMeta {
  return GUIDE_AGENTS[id];
}
